import { Controller } from '@hotwired/stimulus'
import store from '../store'

export default class extends Controller {
  navigateToSectionClicked() {
    store.selectedSectionSqid.set(this.element.dataset.sectionSqid)
    document.getElementById(`section-${this.element.dataset.sectionSqid}`).scrollIntoView({ block: "center" })
    document.getElementById(`toc-link-${this.element.dataset.sectionSqid}`).scrollIntoView()
  }
}
